<template>
    <div class="row">
        <div class="col-xs-4">
            <select-list :id="`day${id}`" v-model="dateModel.day" value-key="value" :list="dayList" placeholder="Day"
                @change="formDate" :error="error" />
        </div>
        <div class="col-xs-4">
            <select-list :id="`month${id}`" v-model="dateModel.month" value-key="label" :list="monthList"
                placeholder="Month" @change="onMonthChange" :error="error" />
        </div>
        <div class="col-xs-4">
            <select-list :id="`year${id}`" v-model="dateModel.year" value-key="label" :list="yearList"
                placeholder="Year" @change="formDate" :error="error" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'DateField',
    props: {
        id: String,
        value: String,
        dob: {
            type: Boolean,
            default: false
        },
        maxYear: {
            type: Number,
            default: new Date().getFullYear() + 5
        },
        error: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dateModel: {
                day: null,
                month: null,
                year: null
            },
            date: null,
            dayList: [],
            monthList: [
                { label: 'Jan', days: 31, number: 1 }, { label: 'Feb', days: 28, number: 2 }, { label: 'Mar', days: 31, number: 3 },
                { label: 'Apr', days: 30, number: 4 }, { label: 'May', days: 31, number: 5 }, { label: 'Jun', days: 30, number: 6 },
                { label: 'Jul', days: 31, number: 7 }, { label: 'Aug', days: 31, number: 8 }, { label: 'Sep', days: 30, number: 9 },
                { label: 'Oct', days: 31, number: 10 }, { label: 'Nov', days: 30, number: 11 }, { label: 'Dec', days: 31, number: 12 }
            ],
            yearList: []
        };
    },
    mounted() {
        const today = new Date();
        const currentYear = today.getFullYear();
        const yearRange = this.dob ? 120 : this.maxYear - currentYear;
        const years = [...Array(yearRange).keys()].map((item) => {
            if (this.dob) {
                return { label: currentYear - item };
            }

            return { label: currentYear + item };
        });

        this.dayList = [...Array(31).keys()].map((item) => ({ label: this.formatDayLabel(item), value: item + 1 }));
        this.yearList = years;
    },
    watch: {
        value() {
            this.setValue();
        }
    },
    methods: {
        formatDayLabel(n) {
            return n + 1 < 10 ? `0${n + 1}` : n + 1;
        },
        numberRange(start, end) {
            return new Array(end - start).fill().map((d, i) => i + start);
        },
        onMonthChange() {
            const find = this.monthList.find(({ label }) => label == this.dateModel.month);
            if (!find) return;
            if (this.dateModel.day > find.days) {
                this.dateModel.day = null;
            }

            this.dayList = [...Array(find.days).keys()].map((item) => ({
                label: this.formatDayLabel(item), value: item + 1
            }));
            this.formDate();
        },
        formDate() {
            if (this.dateModel.day && this.dateModel.month && this.dateModel.year) {
                const monthData = this.monthList.find(({ label }) => label == this.dateModel.month);
                const day = this.dateModel.day < 10 ? `0${this.dateModel.day}` : this.dateModel.day;
                const month = monthData.number < 10 ? `0${monthData.number}` : monthData.number;
                this.date = `${this.dateModel.year}-${month}-${day}`;
            } else {
                this.date = null;
            }

            this.change(this.date);
        },
        setValue() {
            if (this.value) {
                const split = this.value.split('-');
                const [year, month, day] = split.map(i => Number(i));
                this.dateModel.day = day;
                this.dateModel.month = this.monthList[month - 1].label;
                this.dateModel.year = year;
            } else {
                this.dateModel.day = null;
                this.dateModel.month = null;
                this.dateModel.year = null;
            }
        },
        change(value) {
            this.$emit('input', value);
            this.$emit('change', value);
        }
    }
};
</script>

<style lang="scss"></style>
